import { DpNewsFeedActionKeys as keys } from './dpNewsFeedActionKeys';
import * as types from './dpNewsFeedActionTypes';
import { IDpNewsFeedPost } from './dpNewsFeedInterfaces';

export const dpNewsFeedActionCreators = {
  addTag: (tag: string): types.AddDpNewsFeedTag => ({ payload: { tag }, type: keys.ADD_DP_NEWS_FEED_TAG }),
  checkPostAccess: (postId: number): types.CheckDpPostAccess => ({
    payload: { postId },
    type: keys.CHECK_DP_POST_ACCESS
  }),
  deletePostAccess: (dpNewsFeedPostAccessId: number): types.DeleteDpNewsFeedAccess => ({
    payload: { dpNewsFeedPostAccessId },
    type: keys.DELELTE_DP_NEWS_FEED_ACCESS
  }),
  fetchPost: (postId: number): types.FetchDpNewsFeedPost => ({
    payload: { postId },
    type: keys.FETCH_DP_NEWS_FEED_POST
  }),
  fetchPosts: (): types.FetchDpNewsFeedPosts => ({ type: keys.FETCH_DP_NEWS_FEED_POSTS }),
  setPostAccess: (payload: { postId: number; access: string[] }): types.SetDpPostAccess => ({
    payload,
    type: keys.SET_DP_POST_ACCESS
  }),
  setPosts: (payload: IDpNewsFeedPost[]): types.SetDpNewsFeedPosts => ({ payload, type: keys.SET_DP_NEWS_FEED_POST }),
  updatePost: (post: IDpNewsFeedPost, pushFunc: (url: string) => any): types.UpdateDpNewsFeedPost => ({
    payload: { post, pushFunc },
    type: keys.UPDATE_DP_NEWS_FEED_POST
  })
};
